<template>
  <div class="ps-tool">
    <div class="ps-upload">
      <div class="ps-drop" :class="{ 'ps-dragover': dragging }"
        @dragover.prevent="dragging=true" @dragleave="dragging=false" @drop.prevent="onDrop">
        <i class="el-icon-upload" style="font-size:32px;color:#c0c4cc" />
        <p class="ps-drop-text">{{ $t('tool.PdfSplit.dropText') }}</p>
        <p class="ps-drop-hint">{{ $t('tool.PdfSplit.uploadHint') }}</p>
        <input type="file" accept=".pdf" style="display:none" ref="fileInput" @change="onFileChange" />
        <el-button size="small" @click="$refs.fileInput.click()" style="margin-top:8px">{{ $t('tool.PdfSplit.selectFile') }}</el-button>
      </div>
      <div v-if="file" class="ps-file-info">
        <i class="el-icon-document" /> {{ file.name }}
        <span class="ps-file-size">({{ fmtSize(file.size) }})</span>
      </div>
    </div>

    <div class="ps-config" v-if="file">
      <div class="ps-field">
        <label>{{ $t('tool.PdfSplit.pageRange') }}</label>
        <div class="ps-input-row">
          <el-input v-model="pageRange" size="small" :placeholder="$t('tool.PdfSplit.phRange')" class="ps-input" />
          <el-button type="primary" size="small" :loading="splitting" @click="doSplit">
            {{ splitting ? $t('tool.PdfSplit.splitting') : $t('tool.PdfSplit.btnSplit') }}
          </el-button>
        </div>
        <span class="ps-hint">{{ $t('tool.PdfSplit.hintPageRange') }}</span>
      </div>
    </div>

    <div v-if="errorMsg" class="ps-err"><i class="el-icon-warning" /> {{ errorMsg }}</div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name:'PdfSplit',
  data: () => ({ file:null, pageRange:'', splitting:false, errorMsg:'', dragging:false }),
  methods:{
    fmtSize(b) {
      if (!b) return '0 B'
      if (b < 1024) return b + ' B'
      if (b < 1048576) return (b / 1024).toFixed(1) + ' KB'
      return (b / 1048576).toFixed(1) + ' MB'
    },
    onDrop(e) {
      this.dragging = false
      var f = e.dataTransfer.files[0]
      if (f && f.name.toLowerCase().endsWith('.pdf')) { this.file = f; this.errorMsg = '' }
      else this.errorMsg = this.$t('tool.PdfSplit.errNeedPdf')
    },
    onFileChange(e) {
      var f = e.target.files[0]
      if (f) { this.file = f; this.errorMsg = '' }
    },
    doSplit() {
      if (!this.file) return
      if (!this.pageRange.trim()) { this.errorMsg = this.$t('tool.PdfSplit.errNeedPages'); return }
      this.splitting = true; this.errorMsg = ''
      var fd = new FormData()
      fd.append('file', this.file)
      fd.append('pages', this.pageRange.trim())
      axios.post('/api/pub/convert/pdf-split', fd, { timeout:300000 }).then(r => {
        this.splitting = false
        window.location.href = r.data.data
      }).catch(e => {
        this.splitting = false
        this.errorMsg = this.$t('tool.PdfSplit.errSplit') + ': ' + (e.message || '')
      })
    }
  }
}
</script>

<style scoped>
.ps-tool { display: flex; flex-direction: column; gap: 16px; }

.ps-drop {
  border: 2px dashed #d0d5e0; border-radius: 12px;
  padding: 36px; text-align: center; transition: all .2s;
  background: #fafbfc; cursor: pointer;
}
.ps-drop:hover, .ps-dragover { border-color: #4e7cff; background: #f0f4ff; }
.ps-drop-text { font-size: 14px; color: #606266; margin: 10px 0 4px; }
.ps-drop-hint { font-size: 12px; color: #c0c4cc; margin: 0; }

.ps-file-info { font-size: 13px; color: #303133; padding: 8px 12px; background: #f0f9eb; border-radius: 6px; border: 1px solid #e1f3d8; display: flex; align-items: center; gap: 6px; }
.ps-file-size { color: #909399; font-size: 12px; }

.ps-config { margin-top: 4px; }
.ps-field { display: flex; flex-direction: column; gap: 4px; }
.ps-field label { font-size: 12px; font-weight: 600; color: #909399; }
.ps-input-row { display: flex; gap: 10px; align-items: center; }
.ps-input { flex: 1; min-width: 0; max-width: 320px; }
.ps-hint { font-size: 11px; color: #c0c4cc; }

.ps-err { font-size: 13px; color: #f56c6c; display: flex; align-items: center; gap: 4px; }

@media (max-width: 640px) {
  .ps-drop { padding: 24px 16px; }
  .ps-drop-text { font-size: 12px; }
  .ps-input-row { flex-direction: column; align-items: stretch; }
  .ps-input { max-width: none; }
}
</style>

